import { render, staticRenderFns } from "./StudentClass.vue?vue&type=template&id=77a40a89&"
import script from "./StudentClass.vue?vue&type=script&lang=js&"
export * from "./StudentClass.vue?vue&type=script&lang=js&"
import style0 from "./StudentClass.vue?vue&type=style&index=0&id=77a40a89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports